import React from 'react';

type SubMenuItem = {
  href: string;
  label: string;
  rel?: string;
  target?: string;
};

type NavigationSubMenuListProps = { list: SubMenuItem[] };

export default function NavigationSubMenuList({
  list,
}: NavigationSubMenuListProps) {
  return (
    <div className="small text-muted dropdown-meta text-center font-brand-regular">
      <ul className="list-inline">
        {list.map(({ href, label, rel, target }) => (
          <li key={href}>
            <a className="text-muted" href={href} rel={rel} target={target}>
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
